'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../settings/colors');

var _colors2 = _interopRequireDefault(_colors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconHammer = function IconHammer(_ref) {
  var color = _ref.color,
      custom = _objectWithoutProperties(_ref, ['color']);

  return _react2.default.createElement(
    'svg',
    _extends({ fill: 'none', height: '24', viewBox: '0 0 24 24', width: '24' }, custom),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M3.26984127,19.3544974 C3.03449735,19.3544974 2.84656085,19.1648677 2.84656085,18.9312169 C2.84656085,18.6975661 3.03449735,18.5079365 3.26984127,18.5079365 L5.29989418,18.5079365 C5.53354497,18.5079365 5.7231746,18.6975661 5.7231746,18.9312169 C5.7231746,19.1648677 5.53354497,19.3544974 5.29989418,19.3544974 L3.26984127,19.3544974 Z', fill: color }),
      ' ',
      _react2.default.createElement('path', { d: 'M4.96296296,17.6613757 C4.72761905,17.6613757 4.53968254,17.471746 4.53968254,17.2380952 C4.53968254,17.0044444 4.72761905,16.8148148 4.96296296,16.8148148 L6.99301587,16.8148148 C7.22666667,16.8148148 7.4162963,17.0044444 7.4162963,17.2380952 C7.4162963,17.471746 7.22666667,17.6613757 6.99301587,17.6613757 L4.96296296,17.6613757 Z', fill: color }),
      ' ',
      _react2.default.createElement('path', { d: 'M6.65608466,15.968254 C6.42074074,15.968254 6.23280423,15.7786243 6.23280423,15.5449735 C6.23280423,15.3113228 6.42074074,15.1216931 6.65608466,15.1216931 L8.68613757,15.1216931 C8.91978836,15.1216931 9.10941799,15.3113228 9.10941799,15.5449735 C9.10941799,15.7786243 8.91978836,15.968254 8.68613757,15.968254 L6.65608466,15.968254 Z', fill: color }),
      ' ',
      _react2.default.createElement('path', { d: 'M8.34920635,14.2751323 C8.11386243,14.2751323 7.92592593,14.0855026 7.92592593,13.8518519 C7.92592593,13.6182011 8.11386243,13.4285714 8.34920635,13.4285714 L10.3792593,13.4285714 C10.6129101,13.4285714 10.8025397,13.6182011 10.8025397,13.8518519 C10.8025397,14.0855026 10.6129101,14.2751323 10.3792593,14.2751323 L8.34920635,14.2751323 Z', fill: color }),
      ' ',
      _react2.default.createElement('path', { d: 'M10.042328,12.5820106 C9.80698413,12.5820106 9.61904762,12.392381 9.61904762,12.1587302 C9.61904762,11.9250794 9.80698413,11.7354497 10.042328,11.7354497 L12.072381,11.7354497 C12.3060317,11.7354497 12.4956614,11.9250794 12.4956614,12.1587302 C12.4956614,12.392381 12.3060317,12.5820106 12.072381,12.5820106 L10.042328,12.5820106 Z', fill: color }),
      ' ',
      _react2.default.createElement('path', { d: 'M12.2626175,10.2268304 L3.65549427,18.8339536 C3.48255525,19.0075552 3.36461216,19.2189251 3.33214468,19.4130674 C3.31425444,19.5243845 3.32816907,19.6191365 3.36858777,19.6588926 L3.52231134,19.7026243 C3.68663654,19.7026243 3.94968938,19.6158235 4.19418937,19.3713235 C4.19418937,19.3713235 9.93620797,13.6288749 12.8072173,10.7576506 C12.8854477,10.6794143 12.343037,10.1464108 12.2626175,10.2268304 Z M2.43166909,20.5964739 C2.08446585,20.2499332 1.93604309,19.7403926 2.0254943,19.1997097 C2.10169349,18.7305878 2.34751869,18.2674292 2.71857559,17.8963723 L10.9271042,9.68845841 C11.1403886,9.47518995 13.6878526,11.7508568 13.5426965,11.8960238 C10.7388337,14.7000966 5.13110805,20.3082422 5.13110805,20.3082422 C4.67457554,20.7654373 4.08817312,21.0278275 3.52231134,21.0278275 C3.09824631,21.0278275 2.70996177,20.8747666 2.43166909,20.5964739 Z', fill: color }),
      ' ',
      _react2.default.createElement('path', { d: 'M16.2792596,14.0783633 C16.8886898,14.0783633 21.0718169,10.2005956 21.2344338,9.04360792 C21.3970507,7.88662024 15.0987465,1.95159458 14.0136124,2.08353581 C12.9284783,2.21547703 9.26786453,5.76410543 8.92474464,6.87875399 C8.56551275,8.3534423 15.6698294,14.0783633 16.2792596,14.0783633 Z', stroke: color, strokeWidth: '1.4' }),
      ' '
    )
  );
};

IconHammer.propTypes = {
  color: _propTypes2.default.string
};

IconHammer.defaultProps = {
  color: _colors2.default.icons
};

IconHammer.displayName = 'IconHammer';

exports.default = IconHammer;
module.exports = exports.default;